import React from 'react';

const SupportParagraph = () => {
  return (
    <div>
      <h2 className="govuk-heading-m homepage-acp-title py-2 px-3">Support</h2>
      <p className="govuk-body">
        MyWishes Care provides support in areas relating to the platform and
        technical issues that professionals might experience whilst using the
        service.
      </p>
      <p className="govuk-body">
        If you require support for patients and the communities you serve please
        contact your organisation’s manager or relevant colleague.
      </p>
      <h2 className="govuk-heading-m">Technical Support</h2>
      <p className="govuk-body">
        If you require support whilst using MyWishes Care or if there is
        something that you feel we could improve, please let us know using the
        form below.
      </p>
    </div>
  );
};

export default SupportParagraph;
